import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ShareFinancesShared: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="30px"
            height="29px"
            viewBox="0 0 30 29"
            fill="none"
            {...props}
        >
            <path
                d="M14.2289 0.806641C16.0183 0.806641 17.7901 1.15908 19.4433 1.84384C21.0964 2.5286 22.5985 3.53227 23.8638 4.79754C25.1291 6.06281 26.1327 7.56491 26.8175 9.21806C27.5023 10.8712 27.8547 12.6431 27.8547 14.4324C27.8547 16.2218 27.5023 17.9936 26.8175 19.6468C26.1327 21.2999 25.1291 22.802 23.8638 24.0673C22.5985 25.3326 21.0964 26.3363 19.4433 27.021C17.7901 27.7058 16.0183 28.0582 14.2289 28.0582V0.806641Z"
                fill="#CF7135"
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
            <path
                d="M14.2274 28.0598C12.438 28.0598 10.6661 27.7073 9.01299 27.0226C7.35983 26.3378 5.85774 25.3342 4.59246 24.0689C3.32719 22.8036 2.32352 21.3015 1.63876 19.6484C0.954005 17.9952 0.601563 16.2234 0.601562 14.434C0.601562 12.6446 0.954004 10.8728 1.63876 9.21964C2.32352 7.56648 3.32719 6.06439 4.59246 4.79912C5.85773 3.53385 7.35983 2.53018 9.01299 1.84542C10.6661 1.16066 12.438 0.808216 14.2273 0.808216L14.2274 28.0598Z"
                fill="#6DBBF3"
                style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
        </IconSVG>
    );
};
